var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubMangeIcn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_114_273",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_114_273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1538 15.8463H18.8463V12.1537H17.6538V14.6538H15.1538V15.8463ZM12 14.6923C12.7435 14.6923 13.3781 14.4294 13.9038 13.9038C14.4294 13.3781 14.6923 12.7435 14.6923 12C14.6923 11.2565 14.4294 10.6219 13.9038 10.0962C13.3781 9.57058 12.7435 9.30775 12 9.30775C11.2565 9.30775 10.6219 9.57058 10.0963 10.0962C9.57058 10.6219 9.30775 11.2565 9.30775 12C9.30775 12.7435 9.57058 13.3781 10.0963 13.9038C10.6219 14.4294 11.2565 14.6923 12 14.6923ZM5.15375 11.8463H6.34625V9.34625H8.84625V8.15375H5.15375V11.8463ZM2.5 18.5V5.5H21.5V18.5H2.5ZM4 17H20V7H4V17Z",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubMangeIcn);
export default __webpack_public_path__ + "static/media/SubMangeIcn.aa6cffabd6c8725d7c739c4f1064be68.svg";
export { ForwardRef as ReactComponent };